import { getColor } from 'helpers';
import { CSSObject } from 'libs/ui/styled';
import { ColorsDark, ColorsLight, Theme } from 'libs/ui/theme';

import { ButtonColorVariant } from '../types';

const getColorPrimary = (theme: Theme) => ({
  bgColor: getColor(theme, {
    dark: ColorsDark.blue150,
    light: ColorsLight.blue150,
  }),
  hoverBgColor: getColor(theme, {
    dark: ColorsDark.blue200,
    light: ColorsLight.blue200,
  }),
  focusBgColor: getColor(theme, {
    dark: ColorsDark.blue250,
    light: ColorsLight.blue250,
  }),
  textColor: getColor(theme, {
    dark: ColorsDark.black,
    light: ColorsLight.white,
  }),

  hoverTextColor: getColor(theme, {
    dark: ColorsDark.blue100,
    light: ColorsLight.blue100,
  }),
  focusTextColor: getColor(theme, {
    dark: ColorsDark.black,
    light: ColorsLight.white,
  }),

  disableBgColor: getColor(theme, {
    dark: ColorsDark.gray200,
    light: ColorsLight.gray200,
  }),
  disableTextColor: getColor(theme, {
    dark: ColorsDark.gray250,
    light: ColorsLight.gray250,
  }),
});

const getColorRed = (theme: Theme) => ({
  bgColor: getColor(theme, {
    dark: ColorsDark.red100,
    light: ColorsLight.red100,
  }),
  hoverBgColor: getColor(theme, {
    dark: ColorsDark.red150,
    light: ColorsLight.red150,
  }),
  focusBgColor: getColor(theme, {
    dark: ColorsDark.red200,
    light: ColorsLight.red200,
  }),
  textColor: getColor(theme, {
    dark: ColorsDark.white,
    light: ColorsLight.white,
  }),
  hoverTextColor: getColor(theme, {
    dark: ColorsDark.red50,
    light: ColorsLight.red50,
  }),
  focusTextColor: getColor(theme, {
    dark: ColorsDark.red50,
    light: ColorsLight.white,
  }),

  disableBgColor: getColor(theme, {
    dark: ColorsDark.gray200,
    light: ColorsLight.gray200,
  }),
  disableTextColor: getColor(theme, {
    dark: ColorsDark.gray250,
    light: ColorsLight.gray250,
  }),
});

export const getStandardMode = (
  theme: Theme,
  colorVariant: ButtonColorVariant
): CSSObject => {
  const colors =
    colorVariant === 'primary' ? getColorPrimary(theme) : getColorRed(theme);
  return {
    [theme.breakpoints.up('mobile')]: {
      ...theme.typography.bodyBold,
    },
    [theme.breakpoints.down('mobile')]: {
      ...theme.typography.captionBold,
    },

    backgroundColor: colors.bgColor,
    borderRadius: 40,
    height: 64,
    paddingLeft: 64,
    paddingRight: 64,
    color: colors.textColor,

    '&': {
      [theme.breakpoints.down('mobile')]: {
        borderRadius: 32,
        height: 48,
        paddingLeft: 44,
        paddingRight: 44,
      },
    },

    '&:hover': {
      boxShadow: 'none',
      backgroundColor: colors.hoverBgColor,
      color: colors.hoverTextColor,
    } as CSSObject,

    '&:active': {
      boxShadow: 'none',
      backgroundColor: colors.focusBgColor,
      color: colors.focusTextColor,
    } as CSSObject,

    '&:disabled': {
      backgroundColor: colors.disableBgColor,
      color: colors.disableTextColor,
    } as CSSObject,
  };
};
